import React from 'react';
import FeedContainerBig from './FeedContainerBig.jsx';

const FeaturedItem = ({contentContainer, country, showCompetitionName = true, hideIngress = true }) => (
    <div className="row featured-news">
        <div className="template-item col-md-12">
            <FeedContainerBig contentContainer={contentContainer} country={country} hideIngress={hideIngress} showCompetitionName={showCompetitionName} />
        </div>
    </div>
);

export default FeaturedItem;



// WEBPACK FOOTER //
// ./src/component/NewsFeed/FeaturedItem.jsx